import { LayoutProps } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsLayoutProps } from "@jsonforms/react";

function VerticalLayoutComponent({
  uischema,
  schema,
  path,
  visible,
  renderers,
  cells,
  enabled,
}: LayoutProps) {
  if (!visible) return null;

  const layout = uischema as { elements: any[] };

  return (
    <div className="space-y-4">
      {layout.elements.map((element, index) => (
        <JsonFormsDispatch
          key={index}
          uischema={element}
          schema={schema}
          path={path}
          renderers={renderers}
          cells={cells}
          enabled={enabled}
        />
      ))}
    </div>
  );
}

export const VerticalLayout = withJsonFormsLayoutProps(VerticalLayoutComponent);
